module.exports = __webpack_public_path__ + "static/media/get.9ed48aa4.png";